var React = require("react");
var Tab = require("./tab");

var Tabs = React.createClass({
  PropTypes: {
    options: React.PropTypes.arrayOf(React.PropTypes.shape({
      value: React.PropTypes.string,
      label: React.PropTypes.label,
      isSelected: React.PropTypes.bool,
      isDisabled: React.PropTypes.bool,
      id: React.PropTypes.string
    })).isRequired,
    onTabSelect: React.PropTypes.func
  },

  getDefaultProps: function() {
    return {
      onTabSelect: function() {}
    };
  },

  render: function() {
    return (
      <div className="tablist">
        {this.props.options.map(this._mapOption)}
      </div>
    );
  },
  _mapOption: function({value, label, isSelected, id}, i) {
    return <Tab key={i} id={id} value={value} isSelected={isSelected} onTabSelect={this.props.onTabSelect}>{label}</Tab>;
  }
});
module.exports = Tabs;



// WEBPACK FOOTER //
// ./src/advocate/components/tabs/index.jsx